import { useNavigate } from 'react-router-dom';
import styles from './Header.module.css';
import { getAccessToken } from '../../utils/authToken';

const Header = () => {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        const token = getAccessToken();
        if (token) {
            navigate('/home');
        } else {
            navigate('/start');
        }
    };

    return (
        <div className={styles.header}>
            <div className={styles.logo} onClick={handleLogoClick}>TokPlan</div>
        </div>
    )
}

export default Header;
